import { Component } from '@angular/core';

import { TableCellState } from '../../table.state';

@Component({
  selector: 'app-cell-date',
  templateUrl: './cell-date.component.html',
  styleUrls: ['./cell-date.component.scss'],
})
export class CellDateComponent extends TableCellState {}
